// import styled from 'styled-components';
// import { darken } from 'polished';

// export const Container = styled.div`
//   display: flex;
//   justify-content: flex-end;

//   & > button {
//     border: 0;
//     background: none;
//     color: #cbd0d8;
//     border-radius: 50px;
//     height: 45px;
//     width: 45px;
//     margin-left: 10px;
//     transition: color 1s;
//   }

//   #btn-action {
//     :hover {
//       background: ${darken(0.05, '#f2f5fc')};
//       /* color: ${darken(0.1, '#ff6d3c')}; */
//     }
//   }
// `;

// export const Wrapper = styled.div`
//   z-index: 98;
//   display: ${(props) => (props.visible ? 'flex' : 'none')};
//   position: relative;

//   & > ul {
//     position: absolute;
//     right: 0;
//     top: 30px;
//     background: #fff;
//     font-size: 14px;
//     border: 1px solid #dbe1e9;
//     border-radius: 4px;
//     box-shadow: 0px 0px 2px #00000026;
//     min-width: 150px;

//     & > li {
//       display: flex;
//       color: #444;
//       align-items: center;
//       margin: 0 10px;
//       padding: 10px 5px;
//       transition: background 0.3s;

//       &:not(:last-child) {
//         border-bottom: 1px solid #dbe1e9;
//       }

//       svg {
//         margin-right: 5px;
//       }

//       button {
//         flex: 1;
//         display: flex;
//         align-items: center;
//         text-align: left;
//         border: 0;
//         padding: 0 2px;
//         background: none;
//         color: #444;
//       }
//     }
//   }
// `;

import styled, { keyframes } from 'styled-components';
import { darken } from 'polished';

/* ===== Identidade visual (alinhada ao login / Header) =====
   --primary: #ff6d3c   --muted: #cbd0d8   --border: rgba(216, 224, 235, 0.9)
=========================================================== */

const dropIn = keyframes`
  from { opacity: 0; transform: translateY(-8px) scale(0.98); }
  to   { opacity: 1; transform: translateY(0) scale(1); }
`;

export const Container = styled.div`
  display: flex;
  justify-content: flex-end;

  & > button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 45px;
    width: 45px;
    margin-left: 10px;
    border: 0;
    border-radius: 14px;
    background: none;
    color: #cbd0d8;
    cursor: pointer;
    transition: color 0.2s ease, background 0.2s ease, transform 0.2s ease;
  }

  #btn-action {
    :hover {
      color: ${darken(0.1, '#ff6d3c')};
      background: rgba(255, 109, 60, 0.12);
      transform: translateY(-1px);
    }
  }
`;

export const Wrapper = styled.div`
  z-index: 98;
  display: ${(props) => (props.visible ? 'flex' : 'none')};
  position: relative;

  & > ul {
    position: absolute;
    right: 0;
    top: 34px;
    min-width: 180px;
    padding: 8px;

    background: rgba(255, 255, 255, 0.98);
    border: 1px solid rgba(216, 224, 235, 0.9);
    border-radius: 12px;
    box-shadow: 0 18px 44px rgba(23, 38, 59, 0.16),
      0 1px 0 rgba(255, 255, 255, 0.9) inset;
    backdrop-filter: blur(14px);
    font-size: 14px;
    animation: ${dropIn} 0.18s cubic-bezier(0.22, 1, 0.36, 1) both;

    & > li {
      display: flex;
      align-items: center;
      color: #3a4d66;
      border-radius: 9px;
      padding: 10px 12px;
      transition: background 0.18s ease, color 0.18s ease;

      svg {
        margin-right: 8px;
        color: #ff6d3c;
      }

      &:hover {
        background: rgba(255, 109, 60, 0.1);
        color: #17263b;
      }

      button {
        flex: 1;
        display: flex;
        align-items: center;
        text-align: left;
        border: 0;
        padding: 0;
        background: none;
        color: inherit;
        font-weight: 600;
        cursor: pointer;
      }
    }
  }
`;
